export default __webpack_public_path__ + "static/media/Time Span.442f6bbe.svg";